import React from "react";
import { Button } from "@material-ui/core";
import { Link } from 'react-router-dom';
import '../../../styles/landing-common.scss';
import { useGAEventsTracker } from "../../../util/gtag";

export default function MoreInfoAboutFaq(props) {
    const GAEventTracker = useGAEventsTracker(window.location.origin + "/Learn More")
    return (
        <div className="container-fluid">
            <div className="container d-none d-md-block pb-5 px-5">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 px-4 py-4">
                        <h1 className="font-weight-bold pt-4 pb-2 mt-4 jost-bold " id="faqDefault">FAQs</h1>
                        <p>Find answers to frequently asked questions.</p>
                        <Link to="faq">
                            <Button
                                variant="outlined"
                                className="learn_more_btn"
                                onClick={(e) => { GAEventTracker("Header", 1) }}
                            >Learn More</Button>
                        </Link>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 px-4 py-4">
                        <h1 className="font-weight-bold pt-4 pb-2 mt-4 jost-bold" id="tradeDefault">About Us</h1>
                        <p>Learn more about Calque.</p>
                        <a href="/aboutus">
                            <Button
                                variant="outlined"
                                className="learn_more_btn"
                                onClick={(e) => { GAEventTracker("Header", 1) }}
                            > Learn More
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
            <div className="container d-block d-md-none pb-5 px-3">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 px-3 py-4">
                        <h1 className="font-weight-bold pt-4 pb-2 mt-4 jost-bold" id="faqDefault">FAQs</h1>
                        <p>Find answers to frequently asked questions.</p>
                        <Link to="faq">
                            <Button
                                variant="outlined"
                                className="learn_more_btn"
                                onClick={(e) => { GAEventTracker("Header", 1) }}
                            >Learn More</Button>
                        </Link>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 px-3 py-4">
                        <h1 className="font-weight-bold pt-4 pb-2 mt-4 jost-bold" id="tradeDefault">About Us</h1>
                        <p>Learn more about Calque.</p>
                        <a href="/aboutus">
                            <Button
                                variant="outlined"
                                className="learn_more_btn"
                                onClick={(e) => { GAEventTracker("Header", 1) }}
                            > Learn More
                            </Button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}